/* eslint-disable @typescript-eslint/no-explicit-any */
import { TooltipItem, ChartType } from 'chart.js';
import useChartTooltip from 'hooks/useChartTooltip';

export const commonTooltipOptions = {
  titleAlign: 'center' as any,
  bodySpacing: 5,
  padding: 15,
  boxPadding: 3,
  bodyFont: { weight: 'bold' } as any,
  callbacks: {
    label: (tooltipItem: TooltipItem<ChartType>) => {
      return useChartTooltip(tooltipItem, '명', 'count');
    },
    afterLabel: (tooltipItem: TooltipItem<ChartType>) => {
      return useChartTooltip(tooltipItem, '%', 'percentage');
    }
  }
};
